import React from 'react';
import moment from 'moment';
import { 
  Edit, Event, Comment, PersonAdd, 
  PriorityHigh, LocationOn, Sync, 
  TrendingUp, Info, AccountCircle, 
  GroupAdd,
  GroupRemove
} from '@mui/icons-material';
import { useAppData } from '../../../../../../context/AppDataContext';

const LeadActivityTimeline = ({ data }) => {
  const { userDD, getDDDataById, getMasterLabel } = useAppData();

  // Simple name resolver
  const getUserName = (id) => getDDDataById(userDD, id)?.label || `User (${id})`;

  /**
   * Helper to render JSON key-value pairs for Info Updates
   */
  const renderJsonFields = (jsonStr) => {
    try {
      const obj = JSON.parse(jsonStr);
      return Object.entries(obj).map(([key, value]) => {
        let displayVal = value;
        
        // Apply Master Data Labels inside the JSON if keys match
        if (key === 'calendarType') displayVal = getMasterLabel("calendar-type", Number(value));
        //if (key === 'status') displayVal = getMasterLabel("task-status", Number(value));
        //if (key === 'priority') displayVal = getMasterLabel("priority", Number(value));
        
        // Format key: "calendarType" -> "Calendar Type"
        const readableKey = key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
        
        return (
          <div key={key} className="d-flex justify-content-between border-bottom border-light py-1">
            <span className="text-muted" style={{ fontSize: '0.8rem' }}>{readableKey}:</span>
            <span className="fw-medium text-end">{displayVal}</span>
          </div>
        );
      });
    } catch (e) {
      return <div className="text-break">{jsonStr}</div>;
    }
  };

  return (
    <div className="container py-3" style={{height:"80vh", overflow:"scroll"}}>
      <div className="position-relative">
        {/* Timeline Track */}
        <div className="position-absolute border-start border-2 h-100" style={{ left: '16px', top: '0', borderColor: '#eee' }}></div>

        {data.map((item) => {
          // --- Icon & Theme Setup ---
          let icon = <Edit fontSize="small" />;
          let themeColor = '#6c757d';
          let bgColor = '#f8f9fa';

          if  (item.activityType === 'Assignee') { icon = <PersonAdd fontSize="small" />; themeColor = '#0dcaf0'; bgColor = '#e0f7fa'; }
          else if (item.activityType === 'Priority') { icon = <PriorityHigh fontSize="small" />; themeColor = '#dc3545'; bgColor = '#f8d7da'; }
          else if (item.activityType === 'Status') { icon = <Sync fontSize="small" />; themeColor = '#6610f2'; bgColor = '#f3e5f5'; }
          
          
          return (
            <div key={item.id} className="mb-4 d-flex position-relative" style={{ zIndex: 1 }}>
              
              <div className="rounded-circle d-flex align-items-center justify-content-center shadow-sm border border-white"
                style={{ width: '34px', height: '34px', minWidth: '34px', backgroundColor: bgColor, color: themeColor }}>
                {icon}
              </div>

              <div className="ms-3 w-100">
                <div className="d-flex justify-content-between align-items-center">
                  <span className="fw-bold text-capitalize" style={{ fontSize: '0.9rem', color: themeColor }}>
                    {item.activityType.replace('_', ' ')}
                  </span>
                  <small className="text-muted" style={{ fontSize: '0.75rem' }}>{moment(item.created_at).format('lll')}</small>
                </div>
                
                <div className="text-muted mb-2" style={{ fontSize: '0.75rem' }}>
                  <AccountCircle sx={{ fontSize: 14, mr: 0.5 }} />
                  {getUserName(item.userId)}
                </div>

                <div className="card border-0 shadow-sm" style={{ borderLeft: `4px solid ${themeColor}`, borderRadius: '8px' }}>
                  <div className="card-body p-3">
                    <h6 className="small fw-bold border-bottom pb-2 mb-2">{item.title}</h6>
                    
                    <div className="rounded" style={{ backgroundColor: '#fcfcfc', fontSize: '0.85rem' }}>
                      
                      

                    {/* 1 . Status/Priority Change */}
                      {(item.activityType === 'Status' || item.activityType === 'Priority') && (
                        <div>
                          <div className="text-muted">From: {getMasterLabel(item.activityType === 'Status' ? "lead-status" : "priority", Number(item.oldValue))}</div>
                          <div className="fw-bold text-primary">To: {getMasterLabel(item.activityType === 'Status' ? "lead-status" : "priority", Number(item.newValue))}</div>
                        </div>
                      )}

                      {/* 2. Assignment Change */}
                      {item.activityType === 'Assignee' && (
                        <div>
                          <div className="text-muted">Previous: {getUserName(item.oldValue)}</div>
                          <div className="fw-bold text-primary">Assigned: {getUserName(item.newValue)}</div>
                        </div>
                      )}

                    </div>

                    {item.remark && (
                      <div className="mt-3 p-2 bg-light rounded small text-secondary">
                         <Comment sx={{ fontSize: 14, mr: 1, color: themeColor }} />
                         <em>{item.remark}</em>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LeadActivityTimeline;